export function openNewTab(url: string) {
  try {
    const newWindow = window.open(url);
    if (
      newWindow // because browsers can refuse to open windows
    ) {
      newWindow.opener = null; // avoid security risk. See https://mathiasbynens.github.io/rel-noopener/
    } else {
      // if no window was opened then redirect the browser
      window.location.href = url;
    }
  } catch {
    // if any exception occured then redirect the browser. Might cause problems with sessionStorage but they can always back up their browser
    window.location.href = url;
  }
}
